import React from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { useI18n } from "../i18n/I18nProvider";
import { FINAL_CTA } from "../constants/testIds";
import MagneticButton from "../components/MagneticButton";
import { WordsReveal, Reveal } from "../components/Reveal";
import { openWhatsapp } from "../lib/whatsapp";

export const FinalCTA = () => {
  const { t } = useI18n();
  const { scrollYProgress } = useScroll();
  const blur = useTransform(scrollYProgress, [0.85, 1], [4, 0]);
  const _ = blur; // reserved for potential filter use

  return (
    <section
      id="final-cta"
      data-testid={FINAL_CTA.section}
      className="relative bg-black border-t border-white/5 overflow-hidden"
    >
      <div aria-hidden className="absolute inset-0 gaelon-grid-bg opacity-[0.22]" />
      <div
        aria-hidden
        className="absolute inset-0 pointer-events-none"
        style={{
          background:
            "radial-gradient(ellipse at 50% 50%, rgba(255,255,255,0.04), transparent 60%)",
        }}
      />

      <div className="relative mx-auto max-w-[1440px] px-6 md:px-10 lg:px-14 py-40 md:py-56 lg:py-64 text-center flex flex-col items-center">
        <Reveal>
          <span className="font-mono text-[10px] tracking-[0.4em] uppercase text-white/45">
            / GAELON
          </span>
        </Reveal>

        <h2 className="mt-10 font-display tracking-display text-white text-[44px] sm:text-[64px] md:text-[92px] lg:text-[128px] leading-[0.95] font-medium">
          <span className="block"><WordsReveal text={t.finalCta.line1} /></span>
          <span className="block text-white/55"><WordsReveal text={t.finalCta.line2} delay={0.08} /></span>
        </h2>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 1, ease: [0.16, 1, 0.3, 1], delay: 0.5 }}
          className="mt-10 max-w-xl text-white/65 text-[15px] md:text-[17px] leading-[1.65]"
        >
          {t.finalCta.sub}
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 1, ease: [0.16, 1, 0.3, 1], delay: 0.7 }}
          className="mt-14"
        >
          <MagneticButton
            variant="primary"
            data-testid={FINAL_CTA.button}
            onClick={() => openWhatsapp(t.locale)}
            className="px-10 py-5 text-[13px]"
          >
            {t.finalCta.cta}
          </MagneticButton>
        </motion.div>
      </div>
    </section>
  );
};

export default FinalCTA;
